import React from "react";
import { Navigate } from "react-router-dom";

const AdminRoute = ({ children }) => {
  const isAdmin = localStorage.getItem("is_admin") === "true";
  return isAdmin ? children : <Navigate to="/" replace />;
};

export default AdminRoute;
